import slice from './contentSlice';

export * from './contentSlice';

export default slice;
